import { NARROW_SCREEN_HANDLE_SIZE, WIDE_SCREEN_HANDLE_SIZE } from '../detailPanelHandleSize'
import type { TPanelLayoutArgs } from '../types'

export const getRightPanelLayout = ({
  viewportSize,
  insets,
  isWideScreen,
  isOpen,
  draggedSize,
}: TPanelLayoutArgs) => {
  const closedLeft = Math.round(viewportSize.width)
  const right = Math.round(viewportSize.width - 5)
  const maxSize = closedLeft - (isWideScreen ? Math.round(viewportSize.width / 2) : 190)
  const openSize = Math.min(Math.max(draggedSize ?? maxSize, 0), maxSize)
  const left = isOpen ? closedLeft - openSize : closedLeft
  const top = 5 + insets.top
  const bottom = viewportSize.height - 5 - insets.bottom
  const handleSize = isWideScreen ? WIDE_SCREEN_HANDLE_SIZE : NARROW_SCREEN_HANDLE_SIZE
  const tabSize = isWideScreen ? 100 : 60

  return {
    placement: 'right' as const,
    maxSize,
    size: closedLeft - left,
    // A closed panel keeps its open width, so it slides out instead of shrinking
    content: { top, left, width: right - (closedLeft - openSize), height: bottom - top },
    handle: { top, left: left - handleSize, width: handleSize, height: bottom - top },
    tabs: { top: 32 + insets.top, left: left - tabSize, buttonWidth: tabSize, buttonHeight: tabSize },
    childWidth: right - left,
    childHeight: bottom - top,
  }
}
